var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sf-badge',_vm._g({class:[_vm.variant, _vm.size],style:({
    '--badge-color': _vm.variant === 'free' && _vm.textColor,
    '--badge-background': _vm.variant === 'free' && _vm.backgroundColor
  })},_vm.$listeners),[_vm._t("icon"),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }